<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps<{
  error: NuxtError
}>()

const handleError = () => clearError({ redirect: '/' })
</script>

<template>
  <AppError
    :status-code="error.statusCode ?? 500"
    :status-message="error.statusMessage || 'Unknown Error'"
    @action="handleError()"
  />
</template>
